module.exports = __webpack_public_path__ + "static/media/NotoSans-Medium.0a5198a6.otf";